export default {
  'mobile': '(width < 40em)', // up to 640px
  'mobile-phablet': '(width < 48em)', // up to 768px
  'mobile-tablet': '(width < 64em)', // up to 1024px
  // 'mobile-desktop': '(width < 80em)', // up to 1280px
  'mobile-desktop': '(width < 95em)', // up to 1520px
  'phablet': '(40em <= width < 48em)', // 640px to 768px
  'phablet-tablet': '(40em <= width < 64em)', // 640px to 1024px
  // 'phablet-desktop': '(40em <= width < 80em)', // 640px to 1280px
  'phablet-desktop': '(40em <= width < 95em)', // 640px to 1520px
  'phablet-plus': '(width >= 40em)', // from 640px
  'tablet': '(48em <= width < 64em)', // 768px to 1024px
  // 'tablet-desktop': '(48em <= width < 80em)', // 768px to 1280px
  'tablet-desktop': '(48em <= width < 95em)', // 768px to 1520px
  'tablet-plus': '(width >= 48em)', // from 768px
  // 'desktop': '(64em <= width < 80em)', // 1024px to 1280px
  'desktop': '(64em <= width < 95em)', // 1024px to 1520px
  'desktop-plus': '(width >= 64em)', // from 1024px
  // 'widescreen-plus': '(width >= 80em)', // from 1280px
  'widescreen-plus': '(width >= 95em)', // from 1520px
}
